module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('wxc-cell', {
    attrs: {
      "has-top-border": _vm.hasTopBorder,
      "cell-style": {
        backgroundColor: _vm.backgroundColor
      },
      "accessible": true,
      "aria-label": (_vm.title + ",状态为" + (_vm.checked?'已选中':'未选中') + "," + (_vm.disabled?'不可更改':'')),
      "data-evt-wxcCellClicked": ""
    },
    on: {
      "wxcCellClicked": _vm.wxcCellClicked
    }
  }, [_c('p', {
    staticClass: "title-text weex-el weex-text",
    style: ({
      color: _vm.color
    }),
    attrs: {
      "slot": "title",
      "weex-type": "text"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.radioIcon) ? _c('figure', {
    staticClass: "radio weex-el weex-image",
    attrs: {
      "slot": "value",
      "src": _vm.radioIcon,
      "data-img-src": _vm.radioIcon,
      "weex-type": "image"
    },
    slot: "value"
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1756f0bb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1756f0bb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-radio/item.vue
// module id = 210
// module chunks = 0 1